
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2073.909-1762.031a1.562 1.562 0 00.547-.1 3.7 3.7 0 00.566-.273l10.83-6.279a3.1 3.1 0 00.84-.62 1.114 1.114 0 000-1.392 3.027 3.027 0 00-.84-.625l-10.829-6.278a3.7 3.7 0 00-.566-.273 1.562 1.562 0 00-.547-.1 1.109 1.109 0 00-.879.381 1.521 1.521 0 00-.332 1.035v13.108a1.521 1.521 0 00.332 1.035 1.109 1.109 0 00.878.381z"}})])])
          )
        }
      }
    